// import { ethers } from "ethers";
import { useAppSelector } from "../../store/hooks";
import { covalent } from "../constants/baseUrls";
import { TokenData } from "../../store/user/types";
import { CovalentHistReturn } from "../../store/market/types";

type covalentTokenResponse = {
  filteredItems: any[];
  chain_id: string;
}

export const useCovalent = () => {
  const covalent_API_KEY = process.env.REACT_APP_COVALENT_API_KEY;
  return {
    getTokens: async (address: string, chain_id: string): Promise<covalentTokenResponse> => {
        let tokens: TokenData[] = [];
        let responseData = {} as covalentTokenResponse;
      return await fetch(
        covalent +
          `v1/${chain_id}/address/${address}/balances_v2/?quote-currency=USD&format=JSON&nft=false&no-nft-fetch=false&key=${covalent_API_KEY}`
      )
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          // if (resData.error) {
          //   throw new Error("Fetching data failed");
          // }
          if(!resData.error) {
            const filteredItems = resData.data.items.filter((item: any) => {
              if(item && item.quote > 0.01) {
                return true
              } 
              return false
            })
            responseData = {filteredItems, chain_id};
            return responseData;
          }
          return responseData;
        });
    },
    getSolTokens: async (address: string): Promise<covalentTokenResponse> => {
      let tokens: TokenData[] = [];
      let responseData = {} as covalentTokenResponse;
    return await fetch(
      covalent +
        `v1/1399811149/address/${address}/balances_v2/?quote-currency=USD&format=JSON&nft=false&no-nft-fetch=false&key=${covalent_API_KEY}`
    )
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        // if (resData.error) {
        //   throw new Error("Fetching data failed");
        // }
        if(!resData.error) {
          const filteredItems = resData.data.items.filter((item: any) => {
            if(item && item.quote > 0.01) {
              return true
            } 
            return false
          })
          responseData = {filteredItems, chain_id: "1399811149"};
            return responseData;
        }
          return responseData;
      });
  },
    getHistoricalValue: async (address: string, chain_id: string) => {
        return await fetch(
          covalent +
            `v1/${chain_id}/address/${address}/portfolio_v2/?&key=${covalent_API_KEY}`,
            //`v1/${chain_id}/address/${address}/portfolio_v2/?quote-currency=USD&format=JSON&key=${covalent_API_KEY}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }
        )
          .then((res) => {
            return res.json();
          })
          .then((resData) => {
            if (resData.error) {
              throw new Error("Fetching data failed");
            }
            if(!resData.error) {
              //const data = JSON.parse(resData);
              //console.log(JSON.parse(resData))
              return resData;
            }
          });
      },

      getHistoricalValueSol: async (wallet: string) => {
        return await fetch(
          covalent +
            `v1/1399811149/address/${wallet}/portfolio_v2/?&key=${covalent_API_KEY}`
        )
          .then((res) => {
            return res.json();
          })
          .then((resData) => {
            // if (resData.error) {
            //   throw new Error("Fetching data failed");
            // }
            //if(!resData.error) {
              const data = resData;
              //const data: any[] = resData.data.items;
              return data;
            //}
          });
      },
  };
};
